module.exports = "https://la-static.vkplay.ru/promo/universal/img/pic-1-new.a0dc90a2.png";